import { render } from "./OggiPage.vue?vue&type=template&id=3e812c88&scoped=true"
import script from "./OggiPage.vue?vue&type=script&lang=js"
export * from "./OggiPage.vue?vue&type=script&lang=js"

import "./OggiPage.vue?vue&type=style&index=0&id=3e812c88&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e812c88"]])

export default __exports__